import React, {Component} from 'react';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader/root';
import configureStore from "./modules/store";
import Main from "./components/main";
import './App.scss'

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);


class App extends Component {
    render() {
        return (
            <div className="App">
                <Provider store={reduxStore}>
                    <Main/>
                </Provider>
            </div>
        );
    }
}

export default hot(App);
